// 自媒体分类选项
export const CATEGORIES = [
  {
    label: '微信公众号',
    value: 1
  },
  {
    label: '短视频',
    value: 2
  },
  {
    label: '微博',
    value: 3
  },
  {
    label: '数字化大讲堂文字稿',
    value: 4
  },
  {
    label: 'PR/GR',
    value: 6
  },
  {
    label: '线下物料',
    value: 7
  },
  {
    label: '讲义及课件',
    value: 8
  },
  {
    label: '社群内容',
    value: 9
  },
  {
    label: '站内push',
    value: 10
  },
  {
    label: '短信',
    value: 11
  },
  {
    label: '其他外宣素材',
    value: 5
  }
]

// 用户组列表
export const ALL_GROUPS = [
  {
    name: '一级审核组',
    id: 'UG_001000000022469'
  },
  {
    name: '二级审核组',
    id: 'UG_001000000021647'
  },
  {
    name: '内容修改确认组',
    id: 'UG_001000000020640'
  },
  {
    name: '管理员组',
    id: 'UG_001000000019117'
  },
  {
    name: '内容上传人组',
    id: 'UG_001000000026419'
  }
]
